import { render, staticRenderFns } from "./AiSelectedTag.vue?vue&type=template&id=1feaedad&scoped=true"
import script from "./AiSelectedTag.vue?vue&type=script&lang=js"
export * from "./AiSelectedTag.vue?vue&type=script&lang=js"
import style0 from "./AiSelectedTag.vue?vue&type=style&index=0&id=1feaedad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feaedad",
  null
  
)

export default component.exports